<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <CleanPositionList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import CleanPositionList from "@/components/settings/arena/clean-position/CleanPositionList";
import ActionButton from "@/components/button/ActionButton";

export default {
  name: "CleanPosition",
  components: {
    PageTitle,
    ActionButton,
    PageRowWrapper,
    CleanPositionList,
  },
};
</script>
